import { gql } from '@apollo/client';
import { PartnerContactInfo } from '../fragments';

export default gql`
  query partnerContact($id: ID!) {
    partnerContact(id: $id) {
      ...PartnerContactInfo
    }
  }
  ${PartnerContactInfo}
`;
